/**
 * Stable `data-testid` / React Native `testID` for MFA factor radio options.
 * Used by {@link MFAFactorSelector} when `factor.testID` is omitted.
 */
export function mfaFactorOptionTestId(factorId) {
    return `factor-option-${factorId}`;
}
//# sourceMappingURL=mfaFactorOptionTestId.js.map